import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

function cssVar(name: string): string {
  return `hsl(${getComputedStyle(document.documentElement).getPropertyValue(name).trim()})`;
}

export function getChartColors() {
  return {
    tooltipBg: cssVar('--card'),
    tooltipBorder: `1px solid ${cssVar('--border')}`,
    tooltipColor: cssVar('--card-foreground'),
    tickStroke: cssVar('--muted-foreground'),
    lineColor: cssVar('--primary'),
    lineColorAlt: cssVar('--success'),
    successColor: cssVar('--success'),
    warningColor: cssVar('--warning'),
    destructiveColor: cssVar('--destructive'),
    mutedColor: cssVar('--muted-foreground'),
  };
}
